module.exports = __webpack_public_path__ + "img/sliders.85900ccb.svg";